import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { PATCH, DOWNLOAD } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import CustomerDialog from "@/view/pages/partials/Select-Customer.vue";
import { saveAs } from "file-saver";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import EntityDialog from "@/view/pages/partials/Select-Entity.vue";
export default {
  mixins: [CommonMixin, ListingMixin],
  name: "property-list",
  data: function data() {
    return {
      customerDialog: false,
      exportLoading: false,
      pageModule: "property-listing",
      routeAPI: "property",
      routeName: "property",
      routeDetailName: "property.detail",
      status: "all",
      statusList: [],
      moreActions: [
      /*{
        title: "Export Property(s)",
        action: "export_items",
        divider: false,
        icon: "mdi-database-export",
      },*/

      /*{
        title: "Export Current View",
        action: "export_current_view",
        divider: true,
        icon: "mdi-database-export",
      },*/
      {
        title: "Refresh List",
        action: "refresh_list",
        divider: true,
        icon: "mdi-refresh"
      }],
      propertyMoreActions: [{
        title: "Mark as Active",
        icon: "mdi-check-all",
        action: "active"
      }, {
        title: "Mark as In-Active",
        icon: "mdi-check-all",
        action: "inactive"
      }],
      entity: null,
      entityDialog: false
    };
  },
  components: {
    draggable: draggable,
    PageTips: PageTips,
    EntityDialog: EntityDialog,
    PageHeaderCount: PageHeaderCount,
    Barcode: Barcode,
    TableActivity: TableActivity,
    ListingTemplate: ListingTemplate,
    ListingFooter: ListingFooter,
    ListingTable: ListingTable,
    ListingHeader: ListingHeader,
    ListingSearchCriteria: ListingSearchCriteria,
    Dialog: Dialog,
    CustomerDialog: CustomerDialog
  },
  methods: {
    selectEntity: function selectEntity(param) {
      var _this2 = this;

      this.entity = param;
      this.entityDialog = false;
      this.$nextTick(function () {
        _this2.customerDialog = true;
      });
    },
    selectCustomer: function selectCustomer(customer) {
      if (customer > 0) {
        this.$router.push(this.getDefaultRoute("property.create", {
          query: {
            customer: customer
          }
        }));
      }
    },
    getPropertyAddress: function getPropertyAddress(data) {
      var result = [];

      if (this.lodash.isEmpty(data) === false) {
        if (data.unit_no) {
          result.push(data.unit_no);
        }

        if (data.street_1) {
          result.push(data.street_1);
        }

        if (data.street_2) {
          result.push(data.street_2);
        }

        if (data.zip_code) {
          result.push(data.zip_code);
        }
      }

      return result.join(", ");
    },
    moreAction: function moreAction(action) {
      var _this = this;

      switch (action) {
        case "import_items":
          break;

        case "export_items":
          _this.bulkPropertyExport();

          break;

        case "export_current_view":
          _this.exportCurrentView("property");

          break;

        case "refresh_list":
          _this.getRows();

          break;
      }
    },
    updateMoreAction: function updateMoreAction(param) {
      var _this = this;

      switch (param) {
        case "active":
          _this.bulkUpdateProperty({
            properties: _this.selectedRows,
            status: 1
          });

          break;

        case "inactive":
          _this.bulkUpdateProperty({
            properties: _this.selectedRows,
            status: 0
          });

          break;
      }
    },
    bulkUpdateProperty: function bulkUpdateProperty(requestObject) {
      var _this = this;

      _this.$store.dispatch(PATCH, {
        url: "property",
        data: requestObject
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.selectedRows = [];

        _this.getRows();
      });
    },
    bulkPropertyExport: function bulkPropertyExport() {
      var _this = this;

      var fileName = new Date();
      _this.exportLoading = true;

      _this.$store.dispatch(DOWNLOAD, {
        url: "property/export"
      }).then(function (_ref) {
        var data = _ref.data;
        saveAs(data, "property-export-" + fileName.getTime() + ".xlsx");
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.exportLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{
      title: "Property"
    }]);
  },
  beforeMount: function beforeMount() {
    var _this = this;

    _this.lodash.assign(_this.queryParams, _this.$route.query);

    _this.defaultColDefs = [{
      headerName: "",
      field: "id",
      sort: null,
      visible: true,
      fixed: true,
      sortable: false,
      checkbox: true,
      order: 1
    }, {
      headerName: "Property #",
      field: "barcode",
      sort: null,
      visible: true,
      fixed: false,
      sortable: false,
      order: 2
    }, {
      headerName: "Customer Info",
      field: "customer_info",
      sort: null,
      visible: true,
      fixed: false,
      sortable: false,
      order: 3
    }, {
      headerName: "Contact Person",
      field: "contact_person",
      sort: null,
      visible: true,
      fixed: false,
      sortable: false,
      order: 3
    }, {
      headerName: "Property Info",
      field: "property_info",
      sort: null,
      visible: true,
      fixed: false,
      sortable: false,
      order: 4
    }, {
      headerName: "Total",
      field: "total",
      sort: null,
      visible: true,
      fixed: false,
      sortable: false,
      order: 5
    }, {
      headerName: "Created Time",
      child: "created_at",
      field: "added_at",
      sort: null,
      visible: true,
      fixed: false,
      sortable: false,
      order: 6
    }, {
      headerName: "Last Modified Time",
      child: "modified_at",
      field: "updated_at",
      sort: null,
      visible: false,
      fixed: false,
      sortable: false,
      order: 8
    }];

    var defaultColDefs = _this.lodash.filter(_this.defaultColDefs, {
      visible: true
    });

    _this.defaultColShow = defaultColDefs.map(function (col) {
      return col.field;
    });
    _this.status = _this.$route.query.status || _this.status;

    _this.applyColState();

    _this.paginationPageSize = window.localStorage.getItem(_this.pageModule) || 10;
  }
};